import { User, UserApplications, UserCredentials } from '../user';

export class UserPersistRequest {

  uuid: string;
  email: string;
  emailVerified: boolean;
  enabled: boolean;
  firstName: string;
  lastName: string;
  requieredActions: string[];
  timeZone: string;
  language: string;
  tenantUUID: string;
  organizationUUID: string;
  username: string;
  password: string;
  passwordTemporary: boolean;
  superadminApplications: string[];
  adminApplications: string[];
  viewerApplications: string[];
  operatorApplications: string[];

  constructor(userInfo: User, userCredentials: UserCredentials, userApplications: UserApplications) {
    this.uuid = userInfo.uuid;
    this.email = userInfo.email;
    this.emailVerified = userInfo.emailVerified;
    this.enabled = userInfo.enabled;
    this.firstName = userInfo.firstName;
    this.lastName = userInfo.lastName;
    this.requieredActions = userInfo.requieredActions;
    this.timeZone = userInfo.timeZone;
    this.language = userInfo.language;
    this.tenantUUID = userInfo.tenantUUID;
    this.organizationUUID = userInfo.organizationUUID;
    this.username = userInfo.username;
    this.password = userCredentials.value;
    this.passwordTemporary = userCredentials.temporal;
    this.superadminApplications = userApplications.superadmin;
    this.adminApplications = userApplications.admin;
    this.viewerApplications = userApplications.viewer;
    this.operatorApplications = userApplications.operator;
  }
}
